import { InjectionToken } from '@angular/core';

export const UI_LANGUAGES = new InjectionToken('LANGUAGE_TOKEN', {
  providedIn: 'root',
  factory: (): void => undefined,
});
